import { CrudState } from "@/store/Crud/State";

export class State extends CrudState {
  stats: any | null = null;
  wrongAnswer: Record<string, any> = {};
}
